

// Set Default
function setDefault(animateEl,elemento){
    animateEl.css('overflow', 'hidden');
    animateEl.css('height',elemento.find('[data-animate-height]').data('animate-height'));
}
function init() {
    $("[data-animate]").each(function(){
        var elemento    = $(this);
        var dataValue   = elemento.data('animate');
        var animateEl   = elemento.find('[data-animate-element]');
        var dataStart   = elemento.find('[data-start]');
        setDefault(animateEl,elemento);
        dataStart.on('click',function(){
           if(dataStart.data('start') == 'rotate'){
               dataStart.toggleClass('rotate');
           }
            var idFilhoHeight = elemento.find('#'+ dataValue).outerHeight();
            if(animateEl.data('animate-element') == 'close'){
                animateEl.animate({
                    height: idFilhoHeight,
                });
                animateEl.data('animate-element','open'); 
            }else{
                animateEl.css('overflow', 'hidden');
                animateEl.animate({
                    height: elemento.find('[data-animate-height]').data('animate-height'),
                });
                animateEl.data('animate-element','close'); 
            }
        });
    });
}

module.exports = {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/animate.js